import { $Q } from "../utils/query-selector"

function messageComponent(message) {
  const divContainer = document.createElement('div');
  divContainer.classList.add('clipboard-message');
  divContainer.innerHTML = `<span>${message}</span>`;
  $Q('body').appendChild(divContainer);

  const timeId = setTimeout(() =>{
    divContainer.remove()

    if (!$Q('.clipboard-message')) {
      clearTimeout(timeId)
    }
  }, 2000)
}

/**
 * Copy link
 * If the navigator not support clipboard use execCommand
 * @author Daniel Santos
 */
export function copyURLStore() {
  const link = $Q('#share-js')

  link.addEventListener('click', () => {
    const textSave = window.location.href

    if (!navigator.clipboard) {
      const boxOfText = document.createElement('input')
      boxOfText.setAttribute('value', textSave)
      document.body.appendChild(boxOfText);
      boxOfText.select();
      document.execCommand('copy');
      document.body.removeChild(boxOfText);
    } else {
      navigator.clipboard.writeText(textSave)
        .then(() => {
          messageComponent('Copié dans le presse-papier !')
        }).catch(() => messageComponent('Impossible de copier le lien'))
    }
  })
}

/**
 * Share page
 * If the navigator not support clipboard use execCommand
 * @author Daniel Santos
 */
export function shareProduct() {
  const link = $Q('#share-js')

  link.addEventListener('click', () => {
    navigator.share({
      url: Shopify.url,
      title: Shopify.name
    })
    .then(() => {
      console.log('Shared link')
    }).catch(() => console.log('Shared link was impossible'))
  })
}
